import React from 'react';
import { PropsWithChildren, useEffect, useState } from 'react';
import { useWindowDimensions, StyleProp, ViewStyle, Text, View, Pressable, ScrollView, Platform } from 'react-native';
import CreateResponsiveStyle from '../utils/responsiveStyle';
import { Menu, MenuItem, MenuDivider } from 'react-native-material-menu';
import {GlobalVariables} from '../utils/globalVariables';
import IconChevronArrow from '../source/icons/chevron-arrow';
import InputComponent, { enumTypeInput } from './inputComponent';
export class optionsSelectDropDown {
  id?: any;
  label: string = '';
  value: any = '';
  disabled?: boolean = false;
  hovered?: boolean = false;//variable interna de componente
}
type SectionProps = PropsWithChildren<{
  value?: any,
  title?: string,
  onChange?: any,
  required?: boolean,
  disabled?: boolean,
  style?: StyleProp<ViewStyle>,
  dropdownLarge?: boolean,
  options?: optionsSelectDropDown[],
  selected?:number,
  placeholder?:string,
  maxHeight?:number,
  withFilter?:boolean
}>;

function SelectDropDowmComponent({ style, required, title, disabled = false, dropdownLarge, options = [], selected = -1, placeholder, maxHeight = 200, onChange, withFilter = false}: SectionProps): JSX.Element {
  const layout = useWindowDimensions();
  const styles = responsiveStyle(layout);
  const [visibleList, setVisibleList] = useState(false);
  const [statePressable, setStatePessable] = useState('');
  const [widthOptions, setWidthOptions] = useState(380);
  const [selectedIndex, setSelectedIndex] = useState(selected);
  const [textSelected, setTextSelected] = useState('Selecciona');
  const [filterLabel, setFilterLabel] = useState('');
  const toggleList = (val: boolean) => setVisibleList(val);
  useEffect(()=>{
    let text = selectedIndex >= 0 && selectedIndex < options.length ? options[selectedIndex].label : '';
    setTextSelected(text);
  }, [selectedIndex, options]);
  useEffect(()=>{
		if (selected >= 0) {
			setSelectedIndex(selected);
		}
  }, [selected]);
  return (
    <View
      style={[styles('container'), style]}
      onLayout={(event)=>{
        let {width} = event.nativeEvent.layout;
        setWidthOptions(width);
      }}>
      <Text style={[
          styles('title'),
          disabled && styles('disabled'),
        ]}>
        {
          required ?
            <Text style={styles('required')}>*</Text>
            : null
        }
        {
          title ?
            `${title}`
            : ''
        }
      </Text>
      <Menu
        style={{
          width: widthOptions,
          marginTop: withFilter ? 0 : 50,
          maxHeight: maxHeight,
        }}
        visible={visibleList}
        anchor={
          <Pressable
            disabled={disabled}
            onHoverIn={() => setStatePessable('hovered')}
            onHoverOut={() => setStatePessable('none')}
            onPressIn={() => setStatePessable('pressed')}
            onPressOut={() => setStatePessable('pressed')}
            onPress={()=>{
					if (!disabled) {
						toggleList(true);
					}
            }}
            style={[
              styles('pressable'),
              dropdownLarge && styles('dropdownWidth'),
              disabled && styles('disabled'),
              statePressable === 'hovered' && styles('hoverDropdown'),
            ]}
          >
            {
              placeholder && selectedIndex < 0 ?
                <Text style={[styles('pressableText'),styles('placeholder')]}>{placeholder}</Text>
              : <Text style={styles('pressableText')}>{textSelected}</Text>
            }
              <IconChevronArrow fill={GlobalVariables.colors.primary.textColorBlue}  style={styles('icon')} />
          </Pressable>
        }
        onRequestClose={() => toggleList(false)}
      >
        <ScrollView style={{backgroundColor: GlobalVariables.colors.secondary.lightGrey}}>
          {
            withFilter && (
              <InputComponent
                type={enumTypeInput.text}
                placeHolder="Buscar"
                value={filterLabel}
                onInput={(value:string)=>setFilterLabel(value)} />
            )
          }
          {
            options.map((element: optionsSelectDropDown, indexMenuItem: number) => {
              if (element.label.toUpperCase().indexOf(filterLabel.toUpperCase()) >= 0 || filterLabel === '') {
                return (
                  <View key={`${indexMenuItem}-mi`}>
                    <MenuItem
                      style={[styles('menuItem')]
                      }
                      textStyle={styles('textOption')}
                      onPress={() => {
                        setSelectedIndex(indexMenuItem);
                        toggleList(false);
                        if (onChange) {
                          onChange(element.value);
                        }
                      }}>
                      {element.label}
                    </MenuItem>
                    <MenuDivider />
                  </View>
                );
              }
            })
          }
        </ScrollView>
      </Menu>
    </View>
  );
}
const responsiveStyle = CreateResponsiveStyle({
  container: {

  },
  title: {
    fontFamily: '"Helvetica Neue LT Std 75 Bold", sans-serif',
    color: GlobalVariables.colors.primary.textColorBlue,
    fontSize: 16,
    lineHeight: 23,
    fontWeight: 'bold',
  },
  required: {
    fontFamily: '"Helvetica Neue LT Std 75 Bold", sans-serif',
    fontSize: 16,
    lineHeight: 23,
    color: GlobalVariables.colors.secondary.brightBlue,
  },
  pressable: {
    backgroundColor: GlobalVariables.colors.secondary.lightGrey,
    borderRadius: 8,
    marginTop: 5,
    width: 205,
    justifyContent: 'center',
  },
  dropdownWidth: {
    width: '100%',
  },
  hoverDropdown: {
    backgroundColor: GlobalVariables.colors.secondary.white,
  },
  pressableText: {
    borderColor: GlobalVariables.colors.secondary.lightGrey,
    fontSize: 16,
    borderWidth: 1,
    fontFamily: 'sans-serif',
    paddingTop: 12,
    paddingBottom: 12,
    paddingRight: 15,
    paddingLeft: 15,
    borderRadius: 8,
    borderStyle: 'solid',
    color: '#404040',
    minHeight: 45,
  },
  menuItem: {
    backgroundColor: GlobalVariables.colors.secondary.lightGrey,
    width: '100%',
    maxWidth: '100%',
  },
  textOption:{
    fontFamily: 'sans-serif',
    color: '#404040',
    fontSize: 14,
  },
  icon:{
    position: 'absolute',
    height: 18,
    right: 25,
    transform: [{rotate: '90deg'}],
  },
  placeholder:{
    color: '#ccc',
  },
  disabled: {
    opacity: 0.7,
    ...Platform.select({
      web: {
        cursor: 'default',
        pointerEvents: 'none',
      },
    }),
  },
}, {
  pressable: {
    width: '100%',
  },
});
export default SelectDropDowmComponent;
